import { c as _c } from "react/compiler-runtime";
import Link from "@components/Link";
import { Button, Icon } from "@justhome/react-ui";
import useJobTranslation from "@lib/hooks/translations/useJobTranslation";
import { getCareerPath } from "@lib/routing";
import clsx from "clsx";
import { useRouter } from "@lib/hooks/useRouter";
import { FC } from "react";
import Badge, { BadgeBackground } from "../Badge";
type JobCardProps = {
  title: string;
  location?: string | null;
  employmentType?: string | null;
  category?: string | null;
  backgroundColor?: BadgeBackground | null;
  slug?: string | null;
  size?: "md" | "lg";
};
const JobCard: FC<JobCardProps> = t0 => {
  const $ = _c(32);
  const {
    title,
    location,
    employmentType,
    backgroundColor,
    category,
    slug,
    size: t1
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const {
    i18n,
    t
  } = useJobTranslation();
  const router = useRouter();
  let t2;
  if ($[0] !== i18n.language || $[1] !== slug) {
    t2 = getCareerPath(i18n.language, slug);
    $[0] = i18n.language;
    $[1] = slug;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const href = t2;
  let t3;
  if ($[3] !== backgroundColor || $[4] !== category) {
    t3 = category && <Badge background={backgroundColor}>{category}</Badge>;
    $[3] = backgroundColor;
    $[4] = category;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== employmentType) {
    t4 = employmentType && <div className="flex items-center gap-xs"><Icon size={20} type="Handbag" className="!text-primary-800" /><span className="text-body-2 whitespace-nowrap">{employmentType}</span></div>;
    $[6] = employmentType;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== location) {
    t5 = location && <div className="flex items-center gap-xs"><Icon size={20} type="LocalTwo" className="!text-primary-800" /><span className="text-body-2 whitespace-nowrap">{location}</span></div>;
    $[8] = location;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex flex-col gap-3xs items-end mt-2xs">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <div className="flex gap-2m items-start justify-between">{t3}{t6}</div>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = size === "lg";
  const t9 = size === "md";
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = clsx("text-h2-serif text-primary-800 whitespace-normal", {
      "line-clamp-2": t8,
      "line-clamp-1": t9
    });
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== title) {
    t11 = <div className="flex grow h-[76px] w-full"><h2 className={t10}>{title}</h2></div>;
    $[19] = t10;
    $[20] = title;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== href || $[23] !== router || $[24] !== size || $[25] !== t) {
    t12 = size === "lg" && <Button onClick={() => {
      router.push(href);
    }} variant="ghost" href={href} iconEnd="Right" paddingX={false}>{t("see_details")}</Button>;
    $[22] = href;
    $[23] = router;
    $[24] = size;
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== href || $[28] !== t11 || $[29] !== t12 || $[30] !== t7) {
    t13 = <Link href={href} className="h-full p-3s m:pt-3m m:px-3m m:pb-[28px] bg-neutral-0 rounded-3xs flex flex-col gap w-full border border-neutral-50">{t7}{t11}{t12}</Link>;
    $[27] = href;
    $[28] = t11;
    $[29] = t12;
    $[30] = t7;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
export default JobCard;